import { render, staticRenderFns } from "./BlogStyles.vue?vue&type=template&id=5997c701&"
import script from "./BlogStyles.vue?vue&type=script&lang=js&"
export * from "./BlogStyles.vue?vue&type=script&lang=js&"
import style0 from "./BlogStyles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports